export default __webpack_public_path__ + "static/media/mentor.830a0a89.png";